import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getBoostStyles } from './styles/boost';

export const BoostDiscover = ({
  text,
  styleOverrides,
}) => {
  const classes = useDefaultStyles(getBoostStyles({ styleOverrides }));

  return (
    <div className={classnames('hardcode-discover', classes.boostDiscover)}>
      {text}
    </div>
  );
};

BoostDiscover.propTypes = {
  text: PropTypes.string.isRequired,
  styleOverrides: PropTypes.shape({}),
};

BoostDiscover.defaultProps = {
  styleOverrides: {},
};

export const BoostWindows = ({
  welcomeText,
  timeText,
  dateText,
  styleOverrides,
}) => {
  const classes = useDefaultStyles(getBoostStyles({ styleOverrides }));

  return (
    <div className={classnames('hardcode-time', classes.boostWindows)} >
      <div className="welcome" >{welcomeText}</div>
      <div className="time" >{timeText}</div>
      <div className="date" >{dateText}</div>
    </div>
  );
};

BoostWindows.propTypes = {
  welcomeText: PropTypes.string.isRequired,
  timeText: PropTypes.string.isRequired,
  dateText: PropTypes.string.isRequired,
  styleOverrides: PropTypes.shape({}),
};

BoostWindows.defaultProps = {
  styleOverrides: {},
};

